
import { defineComponent, ref, onMounted, watch } from "vue";
import Switch from "./Switch.vue";
import Radio from "./Radio.vue";
import RadioButton from "./RadioButton.vue";
import Checkbox from "./Checkbox.vue";
import Dropdown from "./Dropdown.vue";
import DropdownMultiple from "./DropdownMultiple.vue";
import Text from "./Text.vue";
import Textarea from "./Textarea.vue";
import Range from "./Range.vue";
import Rate from "./Rate.vue";
import LiveSearch from "./LiveSearch.vue";
import LiveSearchMultiple from "./LiveSearchMultiple.vue";
import Cascader from "./Cascader.vue";
import CascaderMultiple from "./CascaderMultiple.vue";

interface Tagging {
  id: number;
  label: string;
  layout: string; //switch, radio, checkbox, dropdown, dropdown-multiple, text, textarea, range, cascader, cascader-multiple, live-search, live-search-multiple
  short_key: string;
  items: Array<TaggingItem>;
}

interface TaggingItem {
  label: string;
  value: string;
}

interface TaggingValueItem {
  short_key: string;
  value: string | Array<string>;
}

interface TaggingConfig {
  switch_short_key: string;
}

export default defineComponent({
  name: "taggings",
  props: {
    taggingItems: {
      type: Array as () => Array<Tagging>,
      required: true,
    },
    taggingValues: {
      type: Array as () => Array<TaggingValueItem>,
    },
    taggingConfig: {
      type: Object as () => TaggingConfig,
    },
    loading: { type: Boolean, default: false },
  },
  components: {
    Switch,
    Radio,
    RadioButton,
    Checkbox,
    Dropdown,
    DropdownMultiple,
    Text,
    Textarea,
    Range,
    Rate,
    LiveSearch,
    LiveSearchMultiple,
    Cascader,
    CascaderMultiple,
  },
  setup(props) {
    const showLoading = ref<boolean>(props.loading);
    const formData = ref({});
    const config = ref<TaggingConfig | undefined>(props.taggingConfig);

    watch(
      () => props.loading,
      (newVal) => {
        showLoading.value = newVal;
      }
    );

    watch(
      () => props.taggingValues,
      (newVal) => {
        setTaggingValue(newVal);
      }
    );

    watch(
      () => props.taggingConfig,
      (newVal) => {
        config.value = newVal;
      }
    );

    const setTaggingValue = (newVal) => {
      let valObj = {};
      newVal.forEach((item) => {
        valObj[item.short_key] = item.value;
      });
      Object.assign(formData.value, valObj);
    };

    onMounted(() => {
      setTaggingValue(props.taggingValues);
    });

    return {
      showLoading,
      formData,
      config,
    };
  },
});
